// core
import { Component, Input } from '@angular/core';

import { RaptorInterstitialService } from '../../services/raptor-interstitial.service';

@Component({
  selector: 'open-raptor-call-to-action',
  templateUrl: './raptor-call-to-action.component.html',
  styleUrls: ['./raptor-call-to-action.component.scss']
})
export class RaptorCallToActionComponent {
  @Input() componentDetails: any;

  constructor(private raptorInterstitialService: RaptorInterstitialService) { }

  doAction(): void {
    this.raptorInterstitialService.openActionInterstitial(this.componentDetails);
  }
}
